import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Principal:',
    desc: 'El manual completo "Metabolismo en Punto de Equilibrio (40+)".'
  }, {
    title: 'El Protocolo 5-5-5:',
    desc: 'La rutina exacta de 15 minutos para encender tus células cada mañana.'
  }, {
    title: 'Mapa de Alimentación de Sostenimiento:',
    desc: 'El orden crítico de los alimentos para eliminar el coma alimenticio.'
  }, {
    title: 'Hojas de Trabajo de Auditoría:',
    desc: 'Para identificar exactamente dónde estás perdiendo energía durante el día.'
  }, {
    title: 'Santuario de Sueño:',
    desc: 'El sistema para eliminar la niebla mental mediante la limpieza de desechos cerebrales nocturnos.'
  }];
  return <section className="py-24 bg-[#275a3a] relative border-y border-white/8 overflow-hidden" data-id="element-148">
      {/* Decorative Elements */}
      <span className="absolute top-8 right-8 text-4xl opacity-[0.07] pointer-events-none select-none" data-id="element-149">
        📖
      </span>
      <span className="absolute bottom-8 left-6 text-5xl opacity-[0.06] pointer-events-none select-none" data-id="element-150">
        🥗
      </span>
      <span className="absolute top-1/3 left-4 text-3xl opacity-[0.06] pointer-events-none select-none" data-id="element-151">
        🌙
      </span>
      <span className="absolute bottom-1/4 right-6 text-3xl opacity-[0.05] pointer-events-none select-none" data-id="element-152">
        🧠
      </span>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-155">
            Todo lo que incluye tu protocolo
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-156">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-start gap-4 bg-[#2f5c3d] p-6 rounded-xl border border-white/8 hover:border-emerald-500/20 transition-colors" data-id="element-157">
              <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0 mt-0.5" data-id="element-158" />
              <p className="text-lg text-gray-300" data-id="element-159">
                <strong className="text-white font-semibold" data-id="element-160">
                  {item.title}
                </strong>{' '}
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}